import { createTheme } from '@material-ui/core/styles';
import { grey, blueGrey, lightGreen } from '@material-ui/core/colors';

const LightTheme = createTheme({
  palette: {
    type: 'light',
    primary: { 500: '#2962ff' },
    secondary: grey,
  },
});

const DarkTheme = createTheme({
  palette: {
    type: 'dark',
    primary: lightGreen,
    secondary: blueGrey,
  },
});

export { LightTheme, DarkTheme };
